module.exports = __webpack_public_path__ + "img/lewe_drzewo.9dd7eade.png";